import { forwardRef } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { Typography, TypographySize, TypographyWeight } from '../core';

const ChatLoadingIndicator = forwardRef<
  HTMLDivElement,
  { displayLoadingText: boolean; loadingText: string }
>(({ displayLoadingText, loadingText }, ref) => (
  <div data-testid="chat-loading-indicator" ref={ref}>
    {displayLoadingText ? (
      <div
        className="relative overflow-hidden"
        data-testid="thinking-skeleton"
        style={{
          background:
            'linear-gradient(90deg, rgba(177, 172, 235, 0.7), rgba(177, 172, 235, 0.4), rgba(177, 172, 235, 0.7))',
          animation: 'skeletonAnimation 2.6s linear infinite',
          backgroundClip: 'text',
          backgroundSize: '200% 100%',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}
      >
        <Typography size={TypographySize.MEDIUM} weight={TypographyWeight.BOLD}>
          {loadingText}
        </Typography>
        <style>{`
          @keyframes skeletonAnimation {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }
        `}</style>
      </div>
    ) : (
      <SkeletonTheme baseColor="rgba(0, 0, 0, 1.0)" highlightColor="#4826FD">
        <Skeleton
          count={3}
          data-testid="skeleton-loader"
          duration={1.3}
          height={18}
        />
      </SkeletonTheme>
    )}
  </div>
));

export default ChatLoadingIndicator;
